import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    title: string;
    children?: ReactNode;
}

function Note({ title, children }:Props) {
    return (
        <Container>
            <Text color={colors.gray6} fontWeight='bold'>{title}</Text>
            <Text color={colors.gray6}>
                {children}
            </Text>
        </Container>
    );
}

const Container = styled.div`
    background-color: var(--color-gray2);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 12px;
    row-gap: 10px;
    width: 100%;
`;

export default Note;
